import { render, staticRenderFns } from "./BcChoiceButton.vue?vue&type=template&id=50ae15cb&scoped=true"
import script from "./BcChoiceButton.vue?vue&type=script&lang=js"
export * from "./BcChoiceButton.vue?vue&type=script&lang=js"
import style0 from "./BcChoiceButton.vue?vue&type=style&index=0&id=50ae15cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae15cb",
  null
  
)

export default component.exports